export type FormatOptions = {
  compactDisplay?: 'short' | 'long';
  locale?: 'en-US';
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  currencySign?: 'accounting' | 'standard';
};

// See /tests/currency.spec.ts for examples and domain logic
const format = (amount: number | string, opts?: FormatOptions) => {
  const defaultFractionalDigits = String(amount).split('.')[1]?.length ?? 0;
  return new Intl.NumberFormat(opts?.locale ?? 'en-US', {
    compactDisplay: opts?.compactDisplay ?? 'long',
    currency: 'USD',
    currencySign: opts?.currencySign ?? 'standard',
    maximumFractionDigits: opts?.maximumFractionDigits ?? opts?.minimumFractionDigits ?? defaultFractionalDigits,
    minimumFractionDigits: opts?.minimumFractionDigits ?? 0,
    notation: opts?.compactDisplay === 'short' ? 'compact' : 'standard',
    style: 'currency',
  }).format(Number(amount));
};

export default {
  format,
};
